import { render, staticRenderFns } from "./GsStatisticsCardCount.vue?vue&type=template&id=4a8e7e69&"
import script from "./GsStatisticsCardCount.vue?vue&type=script&lang=js&"
export * from "./GsStatisticsCardCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports